import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-dialog-copy-route-configuration',
  imports: [MatDialogTitle, MatDialogContent, MatFormField, MatLabel, MatInput, FormsModule, MatDialogActions, MatButton, MatDialogClose],
  templateUrl: './dialog-copy-route-configuration.component.html',
})
export class DialogCopyRouteConfigurationComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogCopyRouteConfigurationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string
  ) {}
}
